import { DATA_TEST_IDS } from '../consts';

export const REPORT_RECIPIENTS_DROPDOWN_GAP = 4;

export const RECIPIENTS_TRIGGER_LABELLED_BY = [
  DATA_TEST_IDS.RECIPIENTS_SELECT_LABEL,
  DATA_TEST_IDS.RECIPIENTS_SELECT_TRIGGER_TITLE,
  DATA_TEST_IDS.RECIPIENTS_SELECT_TRIGGER_COUNT,
].join(' ');
